<script>
import CommonHome from '@/views/Information/CommonHome'
import api from '@/utils/api/operation'
export default {
  name: 'PoliciesHome',
  extends: CommonHome,
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {
    navTitle() {
      return '政策法规'
    }
  },
  methods: {
    loadData(data) {
      let params = {
        page: data.page,
        rows: data.rows,
        BT: this.searchValue
      }
      return api.getPoliciesList(params).then(res => {
        this.list = res.data.rowsList
        return Promise.resolve(res)
      })
    },
    itemClicked(item) {
      this.$router.push({
        name: 'PoliciesDetail',
        query: {
          rid: item.RID
        }
      })
    }
  }
}
</script>
